export const WithMenuName = 'withMenuComponent';
